export const TAWK_SCRIPT_ID = "jobuwin-tawk-to-script";

export function getTawkConfig() {
  const propertyId = String(process.env.REACT_APP_TAWK_PROPERTY_ID || "").trim();
  const widgetId = String(process.env.REACT_APP_TAWK_WIDGET_ID || "").trim();
  return { propertyId, widgetId, enabled: Boolean(propertyId && widgetId) };
}

export function isTawkScriptInjected() {
  return typeof document !== "undefined" && Boolean(document.getElementById(TAWK_SCRIPT_ID));
}

function flushTawkReadyQueue() {
  const queue = window.Tawk_API?.__jobuwinReadyQueue || [];
  if (window.Tawk_API) window.Tawk_API.__jobuwinReadyQueue = [];
  for (const fn of queue) {
    try {
      fn();
    } catch {
      /* ignore tawk callback errors */
    }
  }
}

/** Patch Tawk onLoad before the embed script runs so callbacks are not missed. */
export function ensureTawkOnLoadPatched() {
  if (typeof window === "undefined") return;
  window.Tawk_API = window.Tawk_API || {};
  if (!Array.isArray(window.Tawk_API.__jobuwinReadyQueue)) {
    window.Tawk_API.__jobuwinReadyQueue = [];
  }
  if (window.Tawk_API.__jobuwinOnLoadPatched) return;

  window.Tawk_API.__jobuwinOnLoadPatched = true;
  const previousOnLoad = window.Tawk_API.onLoad;
  window.Tawk_API.onLoad = function onLoad() {
    if (typeof previousOnLoad === "function") previousOnLoad();
    flushTawkReadyQueue();
  };
}

export function runWhenTawkReady(callback) {
  if (typeof window === "undefined") return;
  ensureTawkOnLoadPatched();
  if (typeof window.Tawk_API.hideWidget === "function") {
    callback();
    return;
  }
  window.Tawk_API.__jobuwinReadyQueue.push(callback);
}

export function injectTawkScript(propertyId, widgetId) {
  if (typeof document === "undefined") return false;
  if (document.getElementById(TAWK_SCRIPT_ID)) return true;

  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();
  ensureTawkOnLoadPatched();

  const script = document.createElement("script");
  script.id = TAWK_SCRIPT_ID;
  script.async = true;
  script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");

  const firstScript = document.getElementsByTagName("script")[0];
  if (!firstScript?.parentNode) {
    document.head.appendChild(script);
  } else {
    firstScript.parentNode.insertBefore(script, firstScript);
  }
  return true;
}

export function removeTawkScript() {
  if (typeof document === "undefined") return;
  document.getElementById(TAWK_SCRIPT_ID)?.remove();
  delete window.Tawk_API;
  delete window.Tawk_LoadStart;
}
